export default {
  hello: 'Hi, ',
  dashboard: 'Dashboard',
  logIn: 'Log In',
  logOut: 'Log Out',
  signUp: 'Sign Up',
  takeCheckup: 'Financial Check-Up'
};
